export enum NearestStructureDistance {
  ADJACENT = 'ADJACENT',
  LESS_15M = 'LESS_15M',
  BETWEEN_15M_50M = 'BETWEEN_15M_50M',
  MORE_50M = 'MORE_50M',
}

export const getNearestStructureDistanceEnumLabel = (
  value: NearestStructureDistance
): string => {
  switch (value) {
    case NearestStructureDistance.ADJACENT:
      return $localize`Contigu aux oeuvres de tiers`;
    case NearestStructureDistance.LESS_15M:
      return $localize`Moins de 15m (non mitoyen avec des ouvrages de tiers)`;
    case NearestStructureDistance.BETWEEN_15M_50M:
      return $localize`Entre 15m et 50m`;
    case NearestStructureDistance.MORE_50M:
      return $localize`Plus de 50m`;
    default:
      return '';
  }
};
